export const logout = {
  title: 'You have successfully been logged out of the Carbon Counter.',
  text: `Thanks for taking a look at your carbon footprint. Together, we're a financial force for change.`,
  vancityButton: 'Back to Vancity',
  vancityURL: 'http://www.vancity.com',
};
